import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MenuDetail } from '../../classes/menu-detail';

@Component({
  selector: 'app-menu-detail',
  templateUrl: './menu-detail.component.html',
  styleUrls: ['./menu-detail.component.css']
})
export class MenuDetailComponent implements OnInit, OnChanges {
    @Input() activeMenu: MenuDetail;
    @Input() listMenu: any[];
    @Input() showResponsive: boolean;

    @Output() activeMenuChange: EventEmitter<MenuDetail> = new EventEmitter();

    hasPrev = false;
    hasNext = false;

    constructor() { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.activeMenu && changes.activeMenu.currentValue) {
            this.setActiveMenu(this.activeMenu);
        }
    }

    changeActiveMenu(way: string) {
        const active = this.activeMenu;
        if (this.listMenu.length > 0 && active) {
            const element = this.listMenu.find(function(e) { return e.code === active.code; } );
            const pos = this.listMenu.indexOf(element);
            if (typeof pos !== 'undefined') {
                let menu = null;
                if (way === 'prev' && pos > 0) {
                    menu = this.listMenu[pos - 1];
                }
                if (way === 'next' && pos < this.listMenu.length) {
                    menu = this.listMenu[pos + 1];
                }

                if (typeof menu !== 'undefined' && menu !== null) {
                    this.setActiveMenu(menu);
                }
            }
        }
    }

    setActiveMenu(menu: MenuDetail) {
        this.activeMenu = menu;
        this.activeMenuChange.emit(this.activeMenu);

        if (this.listMenu.length > 0) {
            if (this.listMenu[0].code === menu.code) {
                this.hasPrev = false;
            } else {
                this.hasPrev = true;
            }

            if (this.listMenu[(this.listMenu.length - 1)].code === menu.code) {
                this.hasNext = false;
            } else {
                this.hasNext = true;
            }
        }
    }
}
